import React from 'react';

import {
  AdSlot,
  ContainerId,
  type LayoutType,
  type PlacementId,
  type RecommendationCategories
} from '@schibsted-nmp/advertising-shared';

export function AdvertisingWebComponent(props: AdvertisingWebComponent.Props) {
  return <AdvertisingWebComponent.Forwarded {...props} />;
}

export namespace AdvertisingWebComponent {
  export type Props = React.ComponentProps<typeof Forwarded>;

  export const Forwarded = React.forwardRef<HTMLDivElement, Forwarded.Props>(
    ({ placementId, adIndex, initialLayoutType, categories }, ref) => (
      <advt-component
        initialLayoutType={initialLayoutType}
        categories={categories}
        adIndex={adIndex}
        placementId={placementId}
      >
        <div
          ref={ref}
          id={ContainerId.fromPlacementId(placementId)}
          slot={AdSlot.fromPlacementId(placementId)}
        ></div>
      </advt-component>
    )
  );

  export namespace Forwarded {
    export type Props = {
      placementId: PlacementId;
      adIndex?: number | undefined;

      /** The categories of the item to get the `placementId` for. */
      categories?: RecommendationCategories | undefined;

      /** The initial layout type of the item to get the `placementId` for. (Grid or List) */
      initialLayoutType?: LayoutType | undefined;
    };
  }
}
